import { Wrapper } from "components/Wrapper"
import { Text } from "components/Text"
import { Page } from "components/Page"
import { useTranslator } from "components/Translator"
import { AutoForm } from "components/Form/AutoForm"
import { getInitialValue } from "components/Form"

export function UserSecurityForgottenPage(props) {
  const translator = useTranslator()
  return (
    <Page padded>
      <Wrapper size="small" className="space-y-6 lg:space-y-10">
        <Text variant="headline3" className="text-primary-dark text-center">
          {translator.trans("user.security.forgotten.title", null, "pages")}
        </Text>
        <AutoForm
          schema={props.form}
          initialValue={{
            [props.form.title]: getInitialValue(props.form, null),
          }}
          submitLabel={translator.trans(
            "user.security.forgotten.submitLabel",
            null,
            "pages",
          )}
        />
      </Wrapper>
    </Page>
  )
}
